import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@mlm/ui';
import { useBrand } from '../storefront/lib/hooks';
import { KitGrid } from './kit-grid';

/**
 * "Browse kits" for a member without a slot.
 *
 * Both Browse-kits buttons used to link to `/storefront` — the WHOLE catalog,
 * which has no kit filter, no kit tab and no kit badge (`grep isKit` over the
 * storefront finds nothing). A slotless member was dropped into a general
 * product grid and left to work out which of it activates them.
 *
 * The body is the shared `KitGrid` — the same component as the dashboard's
 * "Pick your activation kit" card, so the two surfaces can't drift.
 */
export function KitPickerDialog({ open, onClose }: { open: boolean; onClose: () => void }) {
  const brand = useBrand();
  return (
    <Dialog
      open={open}
      onOpenChange={(o) => {
        if (!o) onClose();
      }}
    >
      <DialogContent className="max-w-3xl">
        <DialogHeader>
          <DialogTitle>Pick your {brand.activationKitLabel}</DialogTitle>
          <DialogDescription>
            Buying a {brand.kitLabel} creates a Code + PIN you redeem to activate your first slot.
          </DialogDescription>
        </DialogHeader>
        {/*
         * The scroll cap goes on THIS block wrapper and must never move onto the
         * grid itself. A grid container with a definite max-height distributes
         * that height across its auto rows, and every `Card` is `overflow-hidden`
         * — which drops its automatic minimum size to 0 — so the rows compress to
         * fit instead of overflowing and scrolling. That clipped every card to a
         * third of its height: no name, no price, no buttons, and the image cut
         * off mid-frame. A plain block gives its child its natural height.
         *
         * `flex-1 min-h-0` is not the fix either: `DialogContent` is
         * `display: grid`, so flex utilities on its children are inert.
         */}
        <div className="max-h-[60vh] overflow-y-auto pr-1">
          <KitGrid enabled={open} onPicked={onClose} />
        </div>
      </DialogContent>
    </Dialog>
  );
}
